export const SiteFooter: React.FC = () => {
  return (
    <footer className="site-footer border-t py-8 px-4 bg-white">
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-slate-600">
        <p>© {new Date().getFullYear()} Ageiro. All rights reserved.</p>
        <div className="flex gap-6">
          <a href="#security" className="hover:text-slate-900 transition-colors">
            Security
          </a>
          <a href="#connectors" className="hover:text-slate-900 transition-colors">
            Connectors
          </a>
          <a href="#contact" className="hover:text-slate-900 transition-colors">
            Contact
          </a>
          <a href="#" className="hover:text-slate-900 transition-colors">
            Privacy
          </a>
        </div>
      </div>
    </footer>
  );
};
